;
define("cart_quickaddtocart.tpl", function(){});

